<template>
  <div class="container my-5">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-10">
            <div class="form-group form-group-material">
              <label class="control-label">Sign-Off Name</label>
              <p>{{ signOff.name }}</p>
            </div>
          </div>
          <div class="col-md-2 text-right">
            <button
              type="button"
              class="btn btn-sm btn-link"
              v-c-modal:modal="{}"
            >
              <i class="far fa-pencil-alt"></i>
              Edit
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-xl-3">
            <div class="form-group form-group-material">
              <label class="control-label">Evaluation Start</label>
              <p
                class="form-control-plaintext"
                v-if="signOff.project_stage.evaluation_start"
              >
                {{
                  signOff.project_stage.evaluation_start | moment("DD/MM/YYYY")
                }}
              </p>
              <help-block field="type" />
            </div>
          </div>
          <div class="col-md-3 col-xl-3">
            <div class="form-group form-group-material">
              <span class="control-label">Start Date</span>
              <p
                class="form-control-plaintext"
                v-if="signOff.project_stage.evaluation_start"
              >
                {{
                  signOff.project_stage.evaluation_end | moment("DD/MM/YYYY")
                }}
              </p>
            </div>
          </div>
        </div>

        <h3>Client Details</h3>
        <div class="row">
          <div class="col-sm-6 col-md-3">
            <div class="form-group form-group-material">
              <span class="control-label">Client Name</span>
              <router-link
                tag="a"
                :to="{
                  name: 'clients.show',
                  params: { client_id: signOff.contact.client.id },
                }"
                target="_blank"
              >
                <p>{{ signOff.contact.client.company }}</p>
              </router-link>
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="form-group form-group-material">
              <span class="control-label">Contact Name</span>
              <p class="form-control-plaintext">
                {{ signOff.contact.first_name }} {{ signOff.contact.surname }}
              </p>
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="form-group form-group-material">
              <span class="control-label">Contact Email</span>
              <p class="form-control-plaintext">{{ signOff.contact.email }}</p>
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="form-group form-group-material">
              <span class="control-label">Contact Phone</span>
              <p class="form-control-plaintext">
                <a class="text-inherit">{{ signOff.contact.phone }}</a
                ><br />
                <a class="text-inherit">{{ signOff.contact.mobile }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="card-title">Notes</h2>
    <div class="card">
      <div class="card-body"></div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->

    <div class="row">
      <div class="col-6">
        <a href="#" class="text-danger" @click="confirmArchive"
          >Archive Sign-off</a
        >
      </div>
    </div>

    <sign-offs-modal
      ref="modal"
      title="Edit Sign-off"
      :signOff="signOff"
      mode="edit"
    ></sign-offs-modal>
  </div>
</template>

<script>
import { notify } from "utils";
import { debounce, cloneDeep } from "lodash";
import { mapState, mapActions } from "vuex";

import SignOffsModal from "./SignOffsModal";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  components: {
    SignOffsModal,
  },
  data: function () {
    return {
      editBudget: null,
      statuses: ["Draft", "Sent", "Approved"],
      loaded: false,
      tasks: [],
      issues: [],
      approval: {},
    };
  },
  computed: {
    ...mapState("signOff", {
      signOff: "single",
    }),
    ...mapState("client", {
      client: "single",
    }),
  },

  methods: {
    ...mapActions("signOff", {
      getSignOff: "getSingle",
      updateSingle: "updateSingle",
      deleteSingle: "deleteSingle",
    }),

    saveDescription(data) {
      return this.updateSingle({
        id: this.budget.id,
        payload: { description: data },
      });
    },

    confirmArchive() {
      this.$swal({
        title: "Confirm Archive",
        html: "Are you sure you want to archive this sign-off",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Archive",
      }).then(
        () => {
          this.deleteSingle(this.signOff.id).then(
            this.$router.push({ name: "signoffs.index" })
          );
        },
        function () {}
      );
    },
  },
};
</script>
